import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  numberItem: number
}

export default createStyles((theme, { numberItem }: StylesParams) => {
  return {
    root: {
      backgroundColor: theme.colors.neutral[0],
    },
    row: {
      display: 'flex',
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
        gap: rem(16),
      },
      [theme.fn.largerThan('sm')]: {
        gap: rem(24),
      },
    },
    column: {
      flexGrow: 1,
      [theme.fn.largerThan('sm')]: {
        width: `calc((100% - 48px)/2)`,
      },
    },
    mainBannerWrapper: {
      position: 'relative',
      borderRadius: rem(16),
      width: '100%',
    },
    mainBannerCtaBtn: {
      [theme.fn.largerThan('sm')]: {
        height: rem(56),
        fontSize: rem(22),
        padding: '8px 24px 8px 32px',
      },
    },
    mainBannerCtaBtnRightIcon: {
      [theme.fn.largerThan('sm')]: {
        marginLeft: rem(16),
      },
    },
    navigatorRoot: {
      display: 'flex',
      ...(numberItem === 2
        ? { flexDirection: 'column' }
        : numberItem === 3 || numberItem === 4
        ? { flexWrap: 'wrap' }
        : {}),
      [theme.fn.smallerThan('sm')]: {
        gap: rem(16),
        flexDirection: 'row',
      },
      [theme.fn.largerThan('sm')]: {
        height: '100%',
      },
    },
    navigatorItem: {
      flexGrow: 1,
      ...(numberItem === 3 || numberItem === 4
        ? {
            width: `calc((100% - 24px)/2)`,
          }
        : {}),
      [theme.fn.smallerThan('sm')]: {
        width: `calc((100% - 16px)/2)`,
      },
      [theme.fn.largerThan('sm')]: {
        ...(numberItem === 3 || numberItem === 4
          ? {
              height: `calc((100% - 24px)/2)`,
            }
          : {
              height: '100%',
            }),
      },
    },
    navigatorItemWrapper: {},
    navigatorItemDesc: {},
    disclaimer: {
      border: `1px solid ${theme.colors.yellow[1]}`,
      borderRadius: rem(8),
      [theme.fn.smallerThan('sm')]: {
        padding: rem(8),
      },
    },
    disclaimerTitle: { fontWeight: 'normal' },
  }
})
